// Configuration for DonateMate Admin UI
// Values are populated via VITE_* environment variables at build time

export const config = {
  // AWS Region
  region: import.meta.env.VITE_AWS_REGION || 'us-east-2',

  // Environment (dev, staging, production)
  environment: import.meta.env.VITE_ENVIRONMENT || 'dev',

  // API Configuration
  api: {
    url: (import.meta.env.VITE_API_URL || '').replace(/\/$/, ''),
  },

  // Content CDN Configuration
  cdn: {
    url: import.meta.env.VITE_CONTENT_CDN_URL || import.meta.env.VITE_CDN_URL || '',
    bucketName: import.meta.env.VITE_CDN_BUCKET || '',
  },

  // Cognito Configuration
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  },

  // MCP (Model Context Protocol) Configuration
  mcp: {
    httpEndpoint: import.meta.env.VITE_ENVIRONMENT === 'production'
      ? 'https://mcp.donate-mate.com/mcp'
      : 'https://mcp.donate-mate.com/mcp',
    wsEndpoint: import.meta.env.VITE_ENVIRONMENT === 'production'
      ? 'wss://hnho35cprc.execute-api.us-east-2.amazonaws.com/production'
      : 'wss://hnho35cprc.execute-api.us-east-2.amazonaws.com/staging',
    adminEndpoint: import.meta.env.VITE_ENVIRONMENT === 'production'
      ? 'https://mcp.donate-mate.com/admin'
      : 'https://mcp.donate-mate.com/admin',
  },

  // Feature Flags
  features: {
    authentication: true,
    fileManagement: true,
    experiments: true,
    dynamicContent: true,
  },
};

export const getEnvironmentColor = () => {
  switch (config.environment) {
    case 'production':
      return '#ef4444'; // red
    case 'staging':
      return '#f59e0b'; // orange
    case 'dev':
      return '#3db8ff'; // primary blue
    default:
      return '#3db8ff';
  }
};
